import Swiper from 'swiper/bundle';

(function ($) {
    const wrappers = document.querySelectorAll(".news-overview__wrapper")
    wrappers && wrappers.forEach(wrapper => {
        let quoteOptions = {
            loop: true,
            spaceBetween: 24,
            speed: 1000,
            slidesPerView: "auto",
            navigation: {
                nextEl: wrapper.querySelector(".swiper-button-next"),
                prevEl: wrapper.querySelector(".swiper-button-prev")
            },
            breakpoints: {
                1440: {
                    spaceBetween: 24
                },
                1: {
                    spaceBetween: 32
                },
            }

        };

        let quote = new Swiper(wrapper.querySelector(".news-overview__slider"), quoteOptions);

    })

})(jQuery);